import React from "react";

import { listStyles } from "../styles";
import { PlpSparePartFinderSubfamilyLevel } from "@swo/storefront";
import { PlpSitemapLinker } from "../sitemap/plp-sitemap";
import { useAsyncValue } from "../../../hooks";
import { SparePartsLoadingScreen } from "./spare-parts-loading-screen";
import { SparePartsNavigation } from "../shared/spare-parts-navigation";
import { SparePartsFinderBottomNavigation } from "../shared/spare-parts-finder-bottom-navigation";
import { aspectRatioStyles, SparePartsCard } from "../shared/spare-parts-card";
import { Spacer } from "../../../components/_shared-components/arrangement/Space";
import { ContentContainer } from "../../../components/_shared-components/arrangement/Container";
import { SparePartsProductListingPageTranslation } from "@swo/storefront";

export const SelectSubfamilyLevel: React.FC<{
  pathname: string;
  fetcher: ({ categoryKey }: { categoryKey: string }) => Promise<PlpSparePartFinderSubfamilyLevel>;
  categoryKey: string;
  sitemapLinker: PlpSitemapLinker;
  translations: SparePartsProductListingPageTranslation;
}> = props => {
  const { sitemapLinker, categoryKey } = props;

  return useAsyncValue(() => props.fetcher({ categoryKey }), { dataKey: categoryKey }).fold({
    onLoading: () => SparePartsLoadingScreen,
    onError: err => <span>Error</span>,
    onLoaded: ({ subfamilies, selectedCategory, level }) => {
      const backLink = sitemapLinker("root", { openedFilterTabByFilterKey: undefined });

      return (
        <>
          <SparePartsNavigation
            BackNavigation={<SparePartsFinderBottomNavigation link={backLink} translations={props.translations} />}
            category={selectedCategory}
            translations={props.translations}
          />

          <ContentContainer>
            <div>
              <ul css={listStyles}>
                {subfamilies.map(subfamily => (
                  <SparePartsCard
                    key={subfamily.subfamilyKey}
                    href={props.sitemapLinker("subfamily", {
                      subfamilyKey: subfamily.subfamilyKey,
                      categoryKey: selectedCategory.key,
                    })}
                    label={subfamily.name}
                    image={
                      subfamily.image ? { url: subfamily.image.url, sys: { id: undefined } } : undefined
                    }
                    description={subfamily.description}
                    aspectRatioStyles={aspectRatioStyles}
                  />
                ))}
              </ul>
            </div>

            <Spacer size={"md"} />

            <SparePartsFinderBottomNavigation link={backLink} centered={true} translations={props.translations} />
          </ContentContainer>
        </>
      );
    },
  });
};
